import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { Helmet } from "react-helmet";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Journey Mobile Saunas: Authentic Wood Fired Mobile Sauna</title>
        <meta
          name="description"
          content="Embark on a wellness journey with Journey Mobile Saunas, where the therapeutic power of sauna bathing meets the serene beauty of Whangarei's beaches. Experience the warmth of our wood-fired cedar barrel sauna, accommodating up to 8 people, while immersing yourself in the refreshing ocean breeze. Let go of stress and tension as you indulge in this unique blend of relaxation and natural splendor."
        />
      </Helmet>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Gallery data={landingPageData.Gallery} />
      <Testimonials data={landingPageData.Testimonials} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
